export enum GaConstants {
    BOX = 'box',
    TABLE = 'table',
    SLIDER = 'slider',
}